import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { MessageSquarePlus } from "lucide-react";

interface GovernanceComment {
  id: string;
  author: string;
  content: string;
  createdAt: string;
}

interface TorCommentsSectionProps {
  comments?: GovernanceComment[];
}

export function TorCommentsSection({ comments = [] }: TorCommentsSectionProps) {
  const [localComments, setLocalComments] = useState<GovernanceComment[]>(comments);
  const [content, setContent] = useState("");

  const addComment = () => {
    if (!content.trim()) return;
    setLocalComments((prev) => [
      ...prev,
      {
        id: `comment-${Date.now()}`,
        author: "Current Reviewer",
        content: content.trim(),
        createdAt: new Date().toISOString(),
      },
    ]);
    setContent("");
  };

  return (
    <Card className="shadow-card">
      <CardHeader>
        <CardTitle>Review Comments</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Textarea
          value={content}
          onChange={(event) => setContent(event.target.value)}
          placeholder="Add feedback for the committee owner..."
        />
        <Button variant="outline" onClick={addComment}>
          <MessageSquarePlus className="mr-2 h-4 w-4" />
          Add Comment
        </Button>

        <div className="space-y-2">
          {localComments.map((comment) => (
            <div key={comment.id} className="rounded-md border p-3">
              <div className="mb-1 flex items-center justify-between">
                <p className="text-sm font-medium">{comment.author}</p>
                <Badge variant="secondary">{new Date(comment.createdAt).toLocaleDateString()}</Badge>
              </div>
              <p className="text-sm text-muted-foreground">{comment.content}</p>
            </div>
          ))}
          {localComments.length === 0 && (
            <p className="text-sm text-muted-foreground">No comments yet.</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
